import Component from '@glimmer/component';

interface DashboardStatSignature {
  Args: {
    title: string;
    value: { count: number; more: boolean };
    detail?: string;
    icon: string;
  };
  Element: HTMLDivElement;
}

export class DashboardStat extends Component<DashboardStatSignature> {
  get backgroundColor() {
    if (this.args.value.count > 0) {
      return 'text-bg-primary';
    }
    return 'bg-primary-subtle';
  }

  get textColor() {
    if (this.args.value.count > 0) {
      return '';
    }
    return 'text-dark';
  }

  <template>
    <div
      class="card border-0 shadow-sm rounded-4
        {{this.backgroundColor}}
        {{this.textColor}}"
      ...attributes
    >
      <div class="card-body p-3 p-lg-4">
        <div class="d-flex justify-content-between align-items-start mb-3">
          <p class="gud-eyebrow mb-0 {{this.textColor}}">{{@title}}</p>
          <span
            class="rounded-3 bg-white bg-opacity-25 d-inline-flex align-items-center justify-content-center p-2 flex-shrink-0"
            aria-hidden="true"
          >
            <iconify-icon inline icon={{@icon}} class="fs-5" />
          </span>
        </div>
        <p class="display-5 fw-bold lh-1 {{if @detail 'mb-2' 'mb-0'}}">
          {{@value.count}}{{if @value.more "+"}}
        </p>
        {{#if @detail}}
          <p class="small text-opacity-75 mb-0">
            {{@detail}}
          </p>
        {{/if}}
      </div>
    </div>
  </template>
}
